import {ModuleConfiguration} from "../router/model/UserPermission";
import {IMAGE_CROPPER_MODULE_NAME} from "../utils/names/optionalModuleNames";
import 'croppie';
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const ImgCropperModuleConfiguration =
    new ModuleConfiguration(IMAGE_CROPPER_MODULE_NAME, [
        AngularJsMaterialModuleName
    ]);